var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.column.type == 'date')?_c('FilterDate',{attrs:{"column":_vm.column}}):_vm._e(),(_vm.column.type == 'string')?_c('FilterInput',{attrs:{"column":_vm.column}}):[_vm._v(" "+_vm._s(_vm.emptyText)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }